import React, { Dispatch, SetStateAction } from 'react';
import { ContentTemplate, SectionHeader, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../../../api-refactored/user/useGetUserAuthorities';
import { existInArray } from '../../../../utils/ArrayUtils';
import ValidCeqTestDate from './ValidCeqTestDate';

interface ValidCeqTestDateProps {
  selectedExamTypeUuid: string;
  selectedExamTypeDisplay?: string;
  isStrictlyAeisExam: boolean;
  setNoAccess: Dispatch<SetStateAction<boolean>>;
}

export interface ValidCeqTestDateAccessControl {
  hasCreateAccess: boolean;
  hasEditAccess: boolean;
  hasDeleteAccess: boolean;
}

const ValidCeqTestDatePage = ({
  selectedExamTypeUuid,
  selectedExamTypeDisplay,
  isStrictlyAeisExam,
  setNoAccess,
}: ValidCeqTestDateProps) => {
  const { t } = useTranslation();

  const authorities = useGetUserAuthorities();
  const accessControl: ValidCeqTestDateAccessControl = {
    hasCreateAccess: existInArray(
      authorities.data,
      AUTHORITY_NAMES.CP_ADMIN_VALID_CEQ_TEST_DATE_CREATE
    ),
    hasEditAccess: existInArray(
      authorities.data,
      AUTHORITY_NAMES.CP_ADMIN_VALID_CEQ_TEST_DATE_EDIT
    ),
    hasDeleteAccess: existInArray(
      authorities.data,
      AUTHORITY_NAMES.CP_ADMIN_VALID_CEQ_TEST_DATE_DELETE
    ),
  };

  return (
    <ContentTemplate type="full">
      <SectionHeader
        title={`${selectedExamTypeDisplay} ${t(
          'exam->>ValidCeqTestDateConfiguration.ValidCeqTestDate'
        )}`}
      />
      <Typography>
        {t('exam->>ValidCeqTestDateConfiguration.ValidCeqTestDateStatement')}{' '}
      </Typography>
      <ValidCeqTestDate
        isStrictlyAeisExam={isStrictlyAeisExam}
        selectedExamTypeUuid={selectedExamTypeUuid}
        setNoAccess={setNoAccess}
        accessControl={accessControl}
      />
    </ContentTemplate>
  );
};

export default ValidCeqTestDatePage;
